import { jsx as a, jsxs as l } from "react/jsx-runtime";
import { m as U } from "motion/react";
import { useTranslation as z } from "react-i18next";
import R from "dayjs";
import { useAnimateFadeIn as J } from "../../../../../animation/animation.js";
import r from "./trailer-rental-search-widget.module.less.js";
import { useState as I, useEffect as K } from "react";
import { isArrayWithItems as Q } from "../../../../../helpers/array-helper.js";
import { isMobileDevice as X } from "../../../../../helpers/device-helper.js";
import { SecondaryButton as b, SecondaryButtonLink as Z } from "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import { Heading as ee } from "../../../../../components/elements/heading/heading.js";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import ae from "../station-select-search/station-select-search.js";
import { Input as y } from "../../../../../components/form-elements/input/input.js";
import "react-hook-form";
import "../../../../../components/form-elements/file-upload/file-upload.js";
import "../../../../../components/form-elements/select/select.js";
import { AlertSummary as O } from "../../../../../components/elements/alert-summary/alert-summary.js";
import "@radix-ui/react-slider";
import { getTrailerRentalLocationDisplayName as M } from "../../../helpers/trailer-rental-helper.js";
const Ie = ({
  availableStations: C,
  currentStation: o,
  startDate: t,
  endDate: s,
  hasApiError: W,
  linkTo: g,
  title: E,
  textStepOne: T,
  textStepTwo: _,
  isLoading: d,
  collapsed: m,
  setCurrentStation: u,
  onDateChange: N,
  onClickSearchButton: c,
  onChangeBooking: f
}) => {
  const { t: i } = z(), [n, p] = I({
    currentStation: void 0,
    startDate: void 0,
    endDate: void 0
  }), [Y, B] = I(!1);
  K(() => {
    if (Y) {
      const e = L();
      p(e);
    }
  }, [o, t, s, p]);
  const D = (e) => {
    typeof u == "function" && u(e);
  }, h = (e) => {
    typeof N == "function" && N(e);
  }, $ = C?.map((e) => ({
    label: e.name + (e.address ? `, ${e.address}` : ""),
    id: e.locationId,
    filterString: `${e.name} ${e.address} ${e.city}`
  })), j = o ? {
    label: M(o),
    id: o.locationId
  } : null, F = typeof c != "function", A = typeof c == "function", H = J({ whileInView: !0, easing: "easeInOut", duration: 0.3 }), x = R(t).format("D MMMM, YYYY"), k = R(s).format("D MMMM, YYYY"), V = () => {
    typeof f == "function" && f();
  }, L = () => {
    const e = { ...n };
    return e.currentStation = o ? void 0 : i("TRAILER_RENTAL_ERROR_SELECT_STATION"), e.startDate = t ? void 0 : i("TRAILER_RENTAL_ERROR_SELECT_FROM_TIMESLOT"), s ? t && s < t ? e.endDate = i("TRAILER_RENTAL_ERROR_FROM_BEFORE_TO_TIMESLOT") : e.endDate = void 0 : e.endDate = i("TRAILER_RENTAL_ERROR_SELECT_TO_TIMESLOT"), e;
  }, w = () => {
    const e = L(), q = Object.values(e).every((P) => !P);
    p(e), B(!0), A && q && c();
  }, v = Object.values(n).filter((e) => e).map((e) => ({
    text: e
  })), G = X(), S = R().format("YYYY-MM-DD");
  return /* @__PURE__ */ a("div", { className: [r.wrapper].join(" "), children: /* @__PURE__ */ l("div", { className: "max-width padded-sides centered", children: [
    E && /* @__PURE__ */ a(ee, { visualType: "h2", semanticType: "h1", children: E }),
    !m && T && /* @__PURE__ */ a("p", { children: T }),
    m && _ && /* @__PURE__ */ a("p", { children: _ }),
    /* @__PURE__ */ l(U.div, { ...H, className: [r.innerWrapper].join(" "), children: [
      m ? /* @__PURE__ */ l("div", { className: r.collapsedWrapper, children: [
        /* @__PURE__ */ a("p", { className: [r.stationName, "body-l bold"].join(" "), children: M(o) }),
        /* @__PURE__ */ a("p", { className: [r.date, "body-l bold"].join(" "), children: `${x}-${k}` }),
        /* @__PURE__ */ a("div", { className: r.updateBookingWrapper, children: /* @__PURE__ */ a(b, { label: i("CHANGE"), onClick: V, isFullWidth: G }) })
      ] }) : /* @__PURE__ */ l("div", { className: r.bookingContentWrapper, children: [
        /* @__PURE__ */ a("div", { className: r.stationSelectWrapper, children: /* @__PURE__ */ a(
          ae,
          {
            availableStations: $,
            currentStation: j,
            onChooseStation: D,
            isLoading: d,
            isValid: n.currentStation === void 0,
            className: r.resetMarginBottom
          }
        ) }),
        /* @__PURE__ */ a("div", { className: r.inputWrapper, children: /* @__PURE__ */ a(
          y.Text,
          {
            label: i("TRAILER_RENTAL_SEARCH_STARTDATE_LABEL"),
            type: "date",
            name: "startDate",
            onChange: h,
            value: t,
            min: S,
            className: r.input,
            isLoading: d,
            isRequired: !0,
            isValid: !n.startDate
          }
        ) }),
        /* @__PURE__ */ a("div", { className: r.inputWrapper, children: /* @__PURE__ */ a(
          y.Text,
          {
            label: i("TRAILER_RENTAL_SEARCH_ENDDATE_LABEL"),
            type: "date",
            name: "endDate",
            onChange: h,
            value: s,
            min: t || S,
            className: r.input,
            isLoading: d,
            isRequired: !0,
            isValid: !n.endDate
          }
        ) }),
        F && /* @__PURE__ */ a("div", { className: r.buttonWrapper, children: /* @__PURE__ */ a(
          Z,
          {
            url: `${g}?station=${o?.locationId}&startDate=${t}&endDate=${s}`,
            className: r.button,
            label: i("TRAILER_RENTAL_SEARCH_BUTTON_LABEL")
          }
        ) }),
        A && /* @__PURE__ */ a("div", { className: r.buttonWrapper, children: /* @__PURE__ */ a(
          b,
          {
            onClick: w,
            className: r.button,
            label: i("TRAILER_RENTAL_SEARCH_BUTTON_LABEL")
          }
        ) }),
        W && /* @__PURE__ */ a("div", { className: r.alertWrapper, children: /* @__PURE__ */ a(
          O,
          {
            type: "error",
            heading: i("TRAILER_RENTAL_ERROR_FETCH_STATIONS"),
            messages: [{ text: i("ERROR_GENERIC_API_ERROR_BODY") }],
            className: r.alertSummary
          }
        ) }),
        Q(v) && /* @__PURE__ */ a("div", { className: r.alertWrapper, children: /* @__PURE__ */ a(
          O,
          {
            type: "error",
            heading: i("ERROR_MISSING_INFORMATION"),
            messages: v,
            className: r.alertSummary
          }
        ) })
      ] }),
      /* @__PURE__ */ a("div", { className: r.shapeWrapper, children: /* @__PURE__ */ a("div", { className: r.shape }) })
    ] })
  ] }) });
};
export {
  Ie as default
};
